import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "jynova_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(STORAGE_KEY);
    if (!v) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const set = (choice) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ choice, at: new Date().toISOString() })
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 md:max-w-md z-[60]"
      data-testid="cookie-banner"
    >
      <div className="jn-glass-strong rounded-2xl p-5 md:p-6 border border-white/10 shadow-[0_20px_60px_rgba(0,0,0,0.6)]">
        <div className="flex items-start gap-3">
          <div className="flex-1">
            <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-cyan-400 mb-2">
              Cookies
            </div>
            <p className="text-sm text-zinc-300 font-body leading-relaxed">
              We gebruiken alleen essentiële cookies om de website goed te
              laten werken. Geen tracking, geen advertenties.{" "}
              <Link
                to="/privacy"
                className="text-cyan-400 hover:underline"
                data-testid="cookie-banner-privacy-link"
              >
                Lees meer
              </Link>
              .
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              <button
                onClick={() => set("accepted")}
                className="jn-btn-primary px-4 py-2 rounded-full text-xs"
                data-testid="cookie-banner-accept"
              >
                Akkoord
              </button>
              <button
                onClick={() => set("essential_only")}
                className="jn-btn-ghost px-4 py-2 rounded-full text-xs"
                data-testid="cookie-banner-essential"
              >
                Alleen essentieel
              </button>
            </div>
          </div>
          <button
            onClick={() => set("dismissed")}
            className="text-zinc-500 hover:text-white transition p-1"
            aria-label="Sluiten"
            data-testid="cookie-banner-close"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
